import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_54_612)" }, [
      _createElementVNode("path", { d: "M45.0944 22.4809L28.0682 5.07925C27.8629 4.87226 27.6186 4.70798 27.3495 4.59586C27.0804 4.48375 26.7918 4.42603 26.5003 4.42603C26.2087 4.42603 25.9201 4.48375 25.651 4.59586C25.3819 4.70798 25.1376 4.87226 24.9323 5.07925L7.90609 22.503C7.49409 22.9183 7.16871 23.4113 6.94884 23.9534C6.72896 24.4956 6.61897 25.0759 6.62525 25.6609V44.1667C6.62354 45.2972 7.05538 46.3853 7.83183 47.207C8.60828 48.0286 9.67024 48.5212 10.799 48.5834H42.2015C43.3303 48.5212 44.3922 48.0286 45.1687 47.207C45.9451 46.3853 46.377 45.2972 46.3753 44.1667V25.6609C46.377 24.4749 45.9177 23.3346 45.0944 22.4809ZM22.0836 44.1667V30.9167H30.9169V44.1667H22.0836ZM41.9586 44.1667H35.3336V28.7084C35.3336 28.1227 35.1009 27.561 34.6868 27.1469C34.2726 26.7327 33.7109 26.5001 33.1253 26.5001H19.8753C19.2896 26.5001 18.7279 26.7327 18.3137 27.1469C17.8996 27.561 17.6669 28.1227 17.6669 28.7084V44.1667H11.0419V25.5726L26.5003 9.783L41.9586 25.6609V44.1667Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_54_612" }, [
        _createElementVNode("rect", {
          width: "53",
          height: "53"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }